/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { object } from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import StoryBanner from './StoryBanner';
import StoryCopy from './StoryCopy';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import useClickStreamCustomEventsTracking from '../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import StoryBlockSkeleton from '../../../../GraphqlSkeletonComponents/StoryBlockSkeleton';

const useStyles = makeStyles((theme) => ({
    container: {
        margin: '10px 0px',
        paddingBottom: '10px',
    },
}));
const StoryBlock = ({
    data,
}) => {
    if (data?.blocks?.length === 0) { return null; }
    const classes = useStyles();
    const featureFlags =  useSelector(getFeatureFlags);
    const brand = useSelector(getBrand);
    const dispatch = useDispatch();
    const forceStoryTellingVariant = featureFlags['force-storytelling-pdp-variant'];
    const { loading, variables, data: storyTellingData  } = useSalesforcePersonalizedContentQuery({
        queryName: 'storyTellingPDP',
        interactionName: `${brand?.domain} - Get Campaign - Storytelling PDP`,
        featureFlag: featureFlags['is-storytelling-pdp-ab-test-enabled'] && !forceStoryTellingVariant,
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    // CONTROL OR VARIANT(TEST) VALUE fo Story Telling hide and show
    const storyTellingDataUserGroup = storyTellingData?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
    const storyTellingPDPVariant = forceStoryTellingVariant || storyTellingDataUserGroup?.toLowerCase() === 'test';

    useClickStreamCustomEventsTracking({
        salesforceResponse: storyTellingData?.contentSF,
        isFireImpression: true,
        page: 'PDP',
    });

    useEffect(() => {
        if (typeof storyTellingDataUserGroup !== 'undefined' && !window.wuStoryTellingEventFired && storyTellingDataUserGroup) {
            // GA tracking
            const eventParam = {
                eventCategory: 'Experiment',
                eventAction: 'storyTellingPDPVariant',
                eventLabel: storyTellingPDPVariant ? 'Variant' : 'Control',
                feature_detail: storyTellingPDPVariant ? 'Variant' : 'Control',
                feature_element: 'storyTellingPDPVariant',
                feature_category: 'Experiment',
            };
            dispatch(trackEvent(eventParam));
            window.wuStoryTellingEventFired = true;
        }
        return () => {
            window.wuStoryTellingEventFired = false;
        };
    }, [storyTellingDataUserGroup]);

    if (loading || variables?.skip) {
        return <StoryBlockSkeleton />;
    }

    return (
        storyTellingPDPVariant
            ? (
                <div className={classes.container} style={{ backgroundColor: data?.background_color }}>
                    {
                        data.blocks.map((block) => {
                            const blockKey = Object.keys(block);
                            const blockObj = block[blockKey];
                            switch (blockKey[0]) {
                                case 'images': return <StoryBanner data={blockObj} />;
                                case 'copy': return <StoryCopy data={blockObj} />;
                                default: return <></>;
                            }
                        })
                    }
                </div>
            )
            : <></>
    );
};

StoryBlock.propTypes = {
    data: object.isRequired,
};
export default StoryBlock;
